import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  defaultDefinePasswordRequestValues,
  DefinePasswordRequestForm,
  definePasswordRequestSchema,
  useResetPasswordRequestMutation,
} from "@ac-expo/api";
import { useToast, FormInput, Button, Form } from "@ac-expo/ui-components";
import { AuthModalPossibilities } from "@web-app/src/types/authModalPossibilities";
import OwnImage from "@ui/components/ui/event/OwnImage";

type ForgotPasswordFormProps = {
  onSwitchSteps: (step: AuthModalPossibilities) => void;
  onClose: () => void;
};

export function ForgotPasswordForm({
  onSwitchSteps,
  onClose,
}: ForgotPasswordFormProps) {
  const { toast } = useToast();

  const form = useForm<DefinePasswordRequestForm>({
    resolver: zodResolver(definePasswordRequestSchema),
    defaultValues: defaultDefinePasswordRequestValues,
  });

  const { control, handleSubmit } = form;

  const { mutate } = useResetPasswordRequestMutation();

  const onSubmit = (data: DefinePasswordRequestForm) => {
    mutate(
      { ...data, fromWebApp: true },
      {
        onSuccess: () => {
          toast({
            title: "Réinitialisation du mot de passe",
            description:
              "Un email de réinitialisation de mot de passe vous a été envoyé",
          });
          onSwitchSteps("RESETPASSWORDCONFIRMATION");
        },
        onError: (error) => {
          toast({
            title: "Erreur",
            description: error.message,
          });
        },
      }
    );
  };

  return (
    <Form {...form}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4 ">
        <div className="flex flex-col items-center gap-2">
          <OwnImage
            src="/images/logos/logo_connect_events_vertical.png"
            alt="logo avec nom Connect'Events vertical"
            className="static h-28 w-auto"
          />
        </div>
        <div className="text-center">
          <h1 className="text-xl font-bold text-black">Mot de passe oublié</h1>
          <p className="text-center text-sm font-normal text-black">
            Entrez l&apos;adresse email liée à votre compte
          </p>
        </div>
        <div className="w-full space-y-5">
          <FormInput
            control={control}
            name="email"
            label="Email"
            placeholder="olivia@mail.com"
          />
        </div>
        <div className="flex w-full flex-col">
          <Button type="submit" variant="blue" size="lg">
            Suivant
          </Button>
        </div>
      </form>
    </Form>
  );
}

export default ForgotPasswordForm;
